import { useAtomValue } from 'jotai';
import React from 'react';

import { EquipmentDetailsView } from '@/features/equipment-browser/equipment-details/equipment-details-view';
import { useEquipmentPool } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-pool';
import { useEquipmentResponseLoader } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-response-loader';
import { equipmentAtom } from '@/features/equipment-browser/equipment-details/state/selected-equipment.state';

type EquipmentDetailsDrawerProps = {
  onClose: () => void;
};

export const EquipmentDetailsDrawer = ({
  onClose,
}: EquipmentDetailsDrawerProps): React.ReactNode => {
  const equipment = useAtomValue(equipmentAtom);

  // Details-specific hooks - only execute when this drawer is rendered
  useEquipmentPool();
  useEquipmentResponseLoader({
    equipmentId: equipment?.referenceId ?? '',
  });

  if (!equipment) {
    return null;
  }

  return <EquipmentDetailsView onClose={onClose} equipment={equipment} />;
};
